<!-- Maintenance Mode Table -->
@if (isMaintainance(reservation)) {
  <p-table [value]="[reservation]" styleClass="p-datatable-sm" [responsiveLayout]="'scroll'"
    [style]="{'font-size':'12px'}"
    [tableStyle]="{'margin': '0', 'padding': '0', 'border-collapse': 'collapse'}"
    >
    <ng-template pTemplate="body" let-reservation>
      <tr>
        <td style="background:rgb(255,173,51); text-align:center;">
          <b>*** MAINTENANCE ***</b>
        </td>
      </tr>
      <tr>
        <td style="text-align:left;">
          <a [href]="'https://admin.kbmhawaii.com/order/' + reservation?.orderId" target="_blank">Edit</a>
        </td>
      </tr>
    </ng-template>
  </p-table>
}

<!-- Non-Maintenance Table -->
@if (!isMaintainance(reservation)) {
  <p-table [value]="[reservation]" styleClass="p-datatable-sm" [responsiveLayout]="'scroll'"
    [style]="{'font-size':'12px'}"
    [tableStyle]="{'margin': '0', 'padding': '0', 'border-collapse': 'collapse'}">
    <ng-template pTemplate="body" let-reservation>
      <tr>
        <td class="bg-green text-center bd-green" >Nts</td>
        <td class="bg-green text-center bd-green" >A-In</td>
        <td class="bg-green text-center bd-green" >C-In</td>
        <td class="bg-green text-center bd-green" >C-Out</td>
        <td class="bg-green text-center bd-green" >A-Out</td>
        <td class="bg-green text-center bd-green" >Guests</td>
        <td class="bg-green text-center bd-green" >Keys</td>
        <td class="bg-green text-center bd-green" >$Bal</td>
      </tr>
      <tr>
        <td class="text-center bd-green fn-bold ">{{reservation?.numNights}}</td>
        <td class="text-center bd-green fn-bold ">{{reservation?.airportArrivalDateTime | date:'h:mm a'}}</td>
        <td class="text-center bd-green fn-bold ">{{reservation?.checkInDate | date:'E MM/dd'}}</td>
        <td class="text-center bd-green fn-bold ">{{reservation?.checkOutDate | date:'E MM/dd'}}</td>
        <td class="text-center bd-green fn-bold ">{{reservation?.airportDepartureDateTime | date:'h:mm a'}}</td>
        <td class="text-center bd-green fn-bold ">{{reservation?.numAdults}}/{{reservation?.numChildren}}</td>
        <td class="text-center bd-green fn-bold ">{{reservation?.accessCodeFrontDoor}}</td>
        <td class="text-center bd-green fn-bold ">{{reservation?.outStandingBalance}}</td>
      </tr>
    </ng-template>
  </p-table>
}
@if (!isMaintainance(reservation)) {
  <p-table [value]="[reservation]" styleClass="p-datatable-sm"
    [style]="{'font-size':'12px'}"
    [tableStyle]="{'margin': '0', 'padding': '0', 'border-collapse': 'collapse'}">
    <ng-template pTemplate="body" let-res>
      <tr>
        <td class="bg-green text-right">Edit / Guest:</td>
        <td>
          <a [href]="'https://admin.kbmhawaii.com/order/' + res?.orderId" target="_blank">Edit</a>
          {{ res?.guestName }}
          <span class="status-tag">{{ getStatus(res) }}</span>
        </td>
      </tr>
      <tr>
        <td class="bg-green text-right">Email:</td>
        <td>
          @if (res?.emailAddress) {
            <span>
              {{ res.emailAddress }}
              <i class="pi pi-envelope text-primary cursor-pointer ms-1"
                title="Send Email"
              (click)="openEmailDialog(res)"></i>
            </span>
          }
          @if (!res?.emailAddress) {
            <span>-</span>
          }
        </td>
      </tr>
      <tr>
        <td class="bg-green text-right">Tags:</td>
        <td>
          @if (res?.tagJoinAPIS?.length > 0) {
            <div class="tag-pill-wrap">
              @for (tag of res?.tagJoinAPIS; track tag) {
                <!--
                  R-color-on-report — when admin assigns a category color via Manage Tag Categories,
                  apply it to the housekeeping report pill so cleaners see the same swatch as on
                  the reservation detail page. Default styling kicks in when tag.tagColor is null.
                -->
                <span class="tag-pill"
                      [ngStyle]="tag.tagColor ? {'border-color': tag.tagColor, 'background-color': tag.tagColor + '22', 'color': '#222'} : null">
                  {{ tag.name }}
                </span>
              }
            </div>
          } @else {
            -
          }
        </td>
      </tr>
      <tr>
        <td class="bg-green text-right">Contact:</td>
        <td>
          @if (res?.primaryMobilePhone && res?.primaryMobilePhone != null) {
            <span>
              {{ res?.primaryMobilePhone }}
              <i class="pi pi-mobile text-primary cursor-pointer ms-1"
                title="Send SMS to primary number"
              (click)="openSmsDialog(res, res?.primaryMobilePhone)"></i>
            </span>
          }
          @if (res?.mobilePhone && res?.mobilePhone != null) {
            <span class="ms-2">
              {{ res?.mobilePhone }}
              <i class="pi pi-mobile text-primary cursor-pointer ms-1"
                title="Send SMS to alternate number"
              (click)="openSmsDialog(res, res?.mobilePhone)"></i>
            </span>
          }
        </td>
      </tr>
      <tr>
        <td class="bg-green text-right">Inbox:</td>
        <td>
          <span class="cursor-pointer link-text" (click)="openInboxDialog(res)">View Inbox</span>
        </td>
      </tr>
      <tr>
        <td class="bg-green text-right">Conf:</td>
        <td>{{ res?.confirmationNumber }}</td>
      </tr>
      <tr>
        <td class="bg-green text-right">Codes:</td>
        <td>
          @if (res?.accessCodes?.length) {
            @for (accessCode of res?.accessCodes; track accessCode; let i = $index) {
              <span class="small">
                <span><strong>{{getLockLocationName(accessCode)}} : </strong> {{ accessCode.accessCode || '-' }}</span>
              </span>
              @if (i < res?.accessCodes.length - 1) {
                <span>, </span>
              }
            }
          } @else {
            -
          }
        </td>
      </tr>
      <tr>
        <td class="bg-green text-right">Vehicle Bookings:</td>
        <td>
          @if (res?.vehicleBookings?.length) {
            @for (vb of res?.vehicleBookings; track vb; let i = $index) {
              <div class="hk-vehicle-booking-chip mb-1">
                <div>
                  <span class="fw-bold">{{ getVehicleName(vb?.vehiclePref) }} (#{{ vb?.vehicleBookingId }}) : </span>
                  {{ vb.pickUpLocPref }} - {{ vb.dropOffLocPref }}
                </div>
                <div class="small text-muted">
                  <span><strong>Pickup:</strong> {{ vb.pickUpLocPref || '-' }}
                  @if (vb?.pickUpDateTimePref) {
                    <span>
                      &nbsp;{{ vb?.pickUpDateTimePref | date:'MM/dd/yyyy hh:mm a' }}
                    </span>
                  }
                </span>
                &nbsp;|&nbsp;
                <span><strong>Dropoff:</strong> {{ vb.dropOffLocPref || '-' }}
                @if (vb?.dropOffDateTimePref) {
                  <span>
                    &nbsp;{{ vb?.dropOffDateTimePref | date:'MM/dd/yyyy hh:mm a' }}
                  </span>
                }
              </span>
              &nbsp;|&nbsp;
              <span><strong>Agency:</strong> {{ vb.agencyName || '-' }}</span>
              &nbsp;|&nbsp;
              <span><strong>Driver:</strong> {{ vb.primaryDriverName || '-' }}</span>
            </div>
          </div>
          @if (i < res?.vehicleBookings?.length - 1) {
            <span>, </span>
          }
        }
      } @else {
        -
      }
    </td>
  </tr>
  @if (!isCheckoutReservation(res)) {
    <tr>
      <td class="bg-green text-right">Early Checkin:</td>
      <td>{{ res?.earlyCheckinDateTime ? (res.earlyCheckinDateTime | date:'MM/dd/yyyy hh:mm a') : '-' }}</td>
    </tr>
  }
  @if (!isCheckoutReservation(res)) {
    <tr>
      <td class="bg-green text-right">Room Arrival:</td>
      <td>{{ res?.propertyArrivalDateTime ? (res.propertyArrivalDateTime | date:'MM/dd/yyyy hh:mm a') : '-' }}</td>
    </tr>
  }
  @if (isCheckoutReservation(res)) {
    <tr>
      <td class="bg-green text-right">Room Departure:</td>
      <td>{{ res?.propertyDepartureDateTime ? (res.propertyDepartureDateTime | date:'MM/dd/yyyy hh:mm a') : '-' }}</td>
    </tr>
  }
  @if (res?.guestNotes) {
    <tr>
      <td class="bg-green text-right">Notes to Guest:</td>
      <td>{{ res?.guestNotes }}</td>
    </tr>
  }
  @if (res?.specialRequests) {
    <tr>
      <td class="bg-green text-right">Notes from Guest:</td>
      <td>{{ res?.specialRequests }}</td>
    </tr>
  }
  <tr>
    <td class="bg-green text-right">Travel Occasion:</td>
    <td>**{{ res?.travelOccasion }}** {{ res?.travelOccasionNotes }}</td>
  </tr>
  <tr>
    <td class="bg-green text-right">Notes to Ops:</td>
    <td>{{ res?.opsNotes }}</td>
  </tr>
  <tr>
    <!-- <td class="bg-green text-right">Reservation Notes:</td> -->
    <td colspan="2">
      @if (res?.reservationId) {
        <app-notes-chat [config]="notesChatConfig" [noteSourceId]="res?.reservationId" [noteSource]="2">
        </app-notes-chat>
      }
    </td>
  </tr>
  <!-- Housemen (Checkout) -->
  @if (isCheckoutReservation(res) && res?.countRollAwayBed > 0) {
    <tr>
      <td class="bg-green text-right">Housemen:</td>
      <td>__**PICKUP ROLLAWAY {{ res?.countRollAwayBed }}</td>
    </tr>
  }
  <!-- Housemen (Non-Checkout) -->
  @if (!isCheckoutReservation(res)) {
    <tr>
      <td class="bg-green text-right">Housemen:</td>
      <td>
        @if (res?.countRollAwayBed > 0) {
          <div>__ DROP ROLLAWAY: {{ res?.countRollAwayBed }}</div>
        }
        @if (res?.countKingBed > 0) {
          <div>__ KINGS: {{ res?.countKingBed }}</div>
        }
        @if (res?.countQueenBed > 0) {
          <div>__ QUEENS: {{ res?.countQueenBed }}</div>
        }
        @if (res?.countDoubleBed > 0) {
          <div>__ DOUBLES: {{ res?.countDoubleBed }}</div>
        }
        @if (res?.countTwinBed > 0) {
          <div>__ TWINS: {{ res?.countTwinBed }}</div>
        }
        @if (res?.countCouchBed > 0) {
          <div>__ COUCHBED: {{ res?.countCouchBed }}</div>
        }
        @if (res?.countBathroom > 0) {
          <div>__ BATHROOMS: {{ res?.countBathroom }}</div>
        }
      </td>
    </tr>
  }
  <!-- Scheduling -->
  <tr>
    <td class="bg-green text-right">Scheduling:</td>
    <td>
      Last Out:
      <b>
        <a [href]="'https://admin.kbmhawaii.com/order/' + res?.prevOrderId" target="_blank">
          {{ res?.previousCheckOutDiffDays }} days ago
        </a>
      </b>
      . Next In:
      <b>
        <a [href]="'https://admin.kbmhawaii.com/order/' + res?.nextOrderId" target="_blank">
          {{ res?.nextCheckOutDiffDays }} days
        </a>
      </b>
    </td>
  </tr>
</ng-template>
</p-table>
}
